export default "__VITE_ASSET__D6$8j86l__"